document.addEventListener('turbolinks:before-cache', function(){ 
  $('.modal').modal('hide');  
  WebpackerReact.unmountComponents() });

document.addEventListener('turbolinks:load', function() {
   $('form .phonetoy input[name="first_name"]').each(function(i, v) {
        $(v).attr('autocomplete', 'new-password'); 
        $(v).attr('type', 'search'); 

   }) 
})

if (!window.Array.prototype.find) {
  window.Object.defineProperty(window.Array.prototype, 'find', {
    value: function(predicate) {
     // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If IsCallable(predicate) is false, throw a TypeError exception.
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }

      // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
      var thisArg = arguments[1];

      // 5. Let k be 0.
      var k = 0;

      // 6. Repeat, while k < len
      while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return kValue.
        var kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) {
          return kValue;
        }
        // e. Increase k by 1.
        k++;
      }

      // 7. Return undefined.
      return undefined;
    }
  });
}



function update_cart_item_quantity(qty){
  $(".cart_item_count").text(qty);
  $('.cart-item-count').text(qty);

}

function isAndroid(){
   var ua = navigator.userAgent.toLowerCase();
  var isAndroid = ua.indexOf("android") > -1
  return isAndroid;
}

function setAndroidViewport(e){
  if (isAndroid()){
      
       var viewheight = $(window).height();
       var viewwidth = $(window).width();
       var viewport = document.querySelector("meta[name=viewport]");

       viewport.setAttribute("content", "height=" + viewheight + "px, width=device-width, initial-scale=1");
   } 

}

window.update_cart_item_quantity = update_cart_item_quantity;
window.isAndroid = isAndroid;
window.setAndroidViewport = setAndroidViewport;

function closeMenuDelayed(){
  if(document.closing_menu){
    $(".collection-menu .is_active").removeClass("is_active");
  }
}


function wireMenu(){
  document.closing_menu = false;
  $(".collection-menu .nav-level-1").hover(function (event){
    closeMenuDelayed();
    document.closing_menu = false;
    $(this).addClass("is_active");
  },
    function (event){
      document.closing_menu = true;
      window.setTimeout(closeMenuDelayed, 700);
    });

  var slide = "500ms";

  $(".no-double-tap").each(function(){
    $(this).attr("data-disable-with", $(this).html());
  })

  $("#mobile-toggle").on("click", function (e) {
    $("body").addClass("mobile-nav-open");
  });

  $("#close-mobile-nav").on("click", function (e) {
    $("body").removeClass("mobile-nav-open");
    $(".mobile-menu-list-container ul.active").css({
      "right": "-100%",
      "animation": "initial"
    }).removeClass("active");

    $("#mobile-menu__root-list").css({
      "right": "0%",
    }).addClass("active");
  });

  $(".mobile-menu__back").on("click", function (e) {
    e.preventDefault();

    $(".mobile-menu-list-container ul.active").css({
      "animation": "right_out "+ slide,
      "right": "-100%"
    }).removeClass("active");

    $("#" + $(this).data("backto")).addClass("last_active").css({
      "right": "0%",
      "animation": "left_in " + slide
    }).addClass("active");
  });

  $(".mobile-menu__arrow-link").on("click", function (e) {
    e.preventDefault();
    var me = $(this);

    me.parents("ul").css({
      "right": "-100%",
      "animation": "left_out " + slide
    }).removeClass("active");

    $("#" + me.data("open-child")).css({
      "right": "0%",
      "animation": "right_in " + slide
    }).addClass("active");

    $(".mobile-menu").scrollTop(0);
  });
}

document.addEventListener("turbolinks:render", function (event){
  wireMenu();
});


$(function (){
  var url = document.location.toString();

  
  if (url.match('#')) {
    $('.nav-tabs a[href="#' + url.split('#')[1].replace('-tab', '') + '"]').tab('show');
  }

  // Change hash for page-reload
  $('.nav-tabs a').on('shown.bs.tab', function (e) {
    window.location.hash = e.target.hash + "-tab";
  });

  wireMenu();


});





// WEBPACK FOOTER //
// ./app/javascript/store_front/startup.js